type JsonPrimitive = string | number | boolean | null;
type JsonValue = JsonPrimitive | JsonObject | JsonValue[];
interface JsonObject {
  [key: string]: JsonValue;
}

const DEFAULT_FALLBACK: JsonObject = {};

/**
 * Normalizes arbitrary input so it can be safely rendered by ReactJson.
 * - Attempts to parse JSON strings.
 * - Returns plain objects/arrays as-is.
 * - Wraps primitives in an object for consistent display.
 */
export function normalizeJsonInput(input: unknown): JsonValue {
  if (input === null || input === undefined) {
    return DEFAULT_FALLBACK;
  }

  if (typeof input === 'string') {
    const trimmed = input.trim();
    if (!trimmed) {
      return DEFAULT_FALLBACK;
    }

    try {
      const parsed = JSON.parse(trimmed);
      return typeof parsed === 'object' && parsed !== null ? (parsed as JsonValue) : { value: parsed as JsonPrimitive };
    } catch {
      return { value: trimmed };
    }
  }

  if (typeof input === 'object') {
    return input as JsonValue;
  }

  return { value: input as JsonPrimitive };
}


